import React from 'react';
import Layout from '../components/layouts/standard-page.js';
import TranslationSystem from '../components/translation-system.js';
import { FormattedMessage } from 'react-intl';
import { Breadcrumb } from 'react-bootstrap';

export default class Translation extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    getBreadcrumb() {
        return <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={'ui-779'} defaultMessage={''} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={'ui-781'} defaultMessage={''} />
            </Breadcrumb.Item>
        </Breadcrumb>
    }
    render() {
        return (<Layout>{this.getBreadcrumb()}
            <TranslationSystem></TranslationSystem>
        </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/translation.js